import { Link } from 'react-scroll'
import Logo from '../../assets/logo512.png'
import { useToggle } from '../../hooks/igmtink-hooks'
import { useContext } from 'react'
import { ScrollContext } from '../../utils/scroll-observer'

const Navbar = props => {
  const { isToggle, isToggleHandler } = useToggle()
  const { scrollY } = useContext(ScrollContext)

  const mobileNavbar = (
    <ul
      className={`lg:hidden bg-[#f9f9f9] p-4 grid grid-cols-1 gap-4 justify-items-center ${
        !isToggle
          ? 'pointer-events-none invisible'
          : 'pointer-events-auto visible'
      }`}
    >
      <li className="hover:text-blue-500 transition-colors font-bold cursor-pointer">
        <Link
          activeClass="text-blue-500 transition-colors"
          to="settings"
          spy={true}
          smooth={true}
          offset={-56}
        >
          When & Where
        </Link>
      </li>
      <li className="hover:text-blue-500 transition-colors font-bold cursor-pointer">
        <Link
          activeClass="text-blue-500 transition-colors"
          to="gallery"
          spy={true}
          smooth={true}
          offset={-56}
        >
          Gallery
        </Link>
      </li>

      <li className="hover:text-blue-500 transition-colors font-bold cursor-pointer">
        <Link
          activeClass="text-blue-500 transition-colors"
          to="healthProtocol"
          spy={true}
          smooth={true}
          offset={-56}
        >
          Health Protocol
        </Link>
      </li>
      <li className="hover:text-blue-500 transition-colors font-bold cursor-pointer">
        <Link
          activeClass="text-blue-500 transition-colors"
          to="giftIdeas"
          spy={true}
          smooth={true}
          offset={-56}
        >
          Gift Ideas
        </Link>
      </li>
      <li>
        <a
          className="bg-blue-500 hover:bg-blue-600 transition-colors px-6 py-3 rounded-md font-bold shadow-lg"
          href="https://forms.gle/rgNAofXbFoabEk7c7"
        >
          RSVP NOW!
        </a>
      </li>
    </ul>
  )

  const menuBar = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-6 h-6 hover:stroke-blue-500 transition-colors"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
      />
    </svg>
  )

  const closeBar = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-6 h-6 hover:stroke-blue-500 transition-colors"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6 18L18 6M6 6l12 12"
      />
    </svg>
  )

  return (
    <header
      className={`bg-[#f9f9f9] fixed top-0 left-0 right-0 z-50 ${
        scrollY >= 64 ? 'shadow-lg' : 'shadow-none'
      }`}
    >
      <nav
        className={`max-w-screen-2xl mx-auto p-4 ${
          !isToggle ? 'h-16 lg:h-20' : 'h-80'
        } overflow-hidden transition-all`}
      >
        <div className="flex justify-between items-center">
          <a
            className="hover:text-blue-500 font-['Courgette'] text-2xl transition-colors font-bold flex gap-2 items-center justify-start"
            href="/"
          >
            <img className="w-8 h-8" src={Logo} alt="Favicon" />
            Ali
          </a>
          <ul className="hidden bg-[#f9f9f9] lg:flex items-center gap-6">
            <li className="hover:text-blue-500 transition-colors font-bold cursor-pointer">
              <Link
                activeClass="text-blue-500 transition-colors"
                to="settings"
                spy={true}
                smooth={true}
                offset={-56}
              >
                When & Where
              </Link>
            </li>
            <li className="hover:text-blue-500 transition-colors font-bold cursor-pointer">
              <Link
                activeClass="text-blue-500 transition-colors"
                to="gallery"
                spy={true}
                smooth={true}
                offset={-56}
              >
                Gallery
              </Link>
            </li>

            <li className="hover:text-blue-500 transition-colors font-bold cursor-pointer">
              <Link
                activeClass="text-blue-500 transition-colors"
                to="healthProtocol"
                spy={true}
                smooth={true}
                offset={-56}
              >
                Health Protocol
              </Link>
            </li>
            <li className="hover:text-blue-500 transition-colors font-bold cursor-pointer">
              <Link
                activeClass="text-blue-500 transition-colors"
                to="giftIdeas"
                spy={true}
                smooth={true}
                offset={-56}
              >
                Gift Ideas
              </Link>
            </li>
          </ul>
          <a
            className="hidden lg:block bg-blue-500 hover:bg-blue-600 transition-colors px-6 py-3 rounded-md font-bold shadow-lg"
            href="https://forms.gle/rgNAofXbFoabEk7c7"
          >
            RSVP NOW!
          </a>
          <button className="lg:hidden" onClick={isToggleHandler}>
            {!isToggle ? menuBar : closeBar}
          </button>
        </div>

        {mobileNavbar}
      </nav>
    </header>
  )
}

export default Navbar
